import http from '@/http-common';

class SessionService {
  async get(filial) {
    return http.get(`/session/${filial || 0}`);
  }
}

export default new SessionService();
